// extracted by mini-css-extract-plugin
module.exports = {"main":"Loader_main__RXgnF","content":"Loader_content__3jxZe"};